import { render } from "./RiskProfileView.vue?vue&type=template&id=9fd98ca6&scoped=true"
import script from "./RiskProfileView.vue?vue&type=script&lang=js"
export * from "./RiskProfileView.vue?vue&type=script&lang=js"

import "./RiskProfileView.vue?vue&type=style&index=0&id=9fd98ca6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd98ca6"]])

export default __exports__